import { render, staticRenderFns } from "./OrdersManagement.vue?vue&type=template&id=a195f9d6"
import script from "./OrdersManagement.vue?vue&type=script&lang=js"
export * from "./OrdersManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports